import React from 'react';
import { Popover, Whisper, Checkbox, Dropdown, IconButton, Table, CellProps } from 'rsuite';
import MoreIcon from '@rsuite/icons/legacy/More';
import AvatarIcon from '@rsuite/icons/legacy/Avatar';
import { FaUser } from 'react-icons/fa';

const { Cell } = Table;

export const NameCell = ({ rowData, dataKey, ...props }: CellProps) => {
  const speaker = (
    <Popover title={rowData.firstname }>
      <p>
        <b>name:</b> {rowData.name}
      </p>
      <p>
        <b>authorizedHomeOfficeDays:</b> {rowData.authorizedWfhDays}
      </p>
      <p>
        <b>daysPerWeekWithBalance:</b> {rowData.daysPerWeekWithBalance}
      </p>
      <p>
        <b>daysPerWeekWithoutBalance:</b> {rowData?.daysPerWeekWithoutBalance}
      </p>
   
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper placement="top" speaker={speaker}>
        <a>{rowData.name}</a>
      </Whisper>
    </Cell>
  );
};



export const CheckCell = ({
  rowData,
  onChange,
  checkedKeys,
  dataKey,
  ...props
}: CellProps & {
  checkedKeys: number[];
  onChange: (value: any, checked: boolean) => void;
}) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div style={{ lineHeight: '46px' }}>
      <Checkbox
        value={rowData[dataKey!]}
        inline
        onChange={onChange}
        checked={checkedKeys?.some(item => item === rowData[dataKey!])}
      />
    </div>
  </Cell>
);

const renderMenu = ({ onClose, left, top, className }: any, ref) => {
  const handleSelect = eventKey => {
    onClose();
    console.log(eventKey);
  };
  return (
    <Popover ref={ref} className={className} style={{ left, top }} full>
      <Dropdown.Menu onSelect={handleSelect}>
        <Dropdown.Item eventKey={1}>Edit</Dropdown.Item>
        <Dropdown.Item eventKey={5}>Block</Dropdown.Item>
      </Dropdown.Menu>
    </Popover>
  );
};

export const ActionCell = props => {
  return (
    <Cell {...props} className="link-group">
      {/* <Whisper placement="autoVerticalEnd" trigger="click" speaker={renderMenu}>
        <IconButton appearance="subtle" icon={<MoreIcon />} />
      </Whisper> */}
      <IconButton appearance="subtle" icon={<MoreIcon />} />
    </Cell>
  );
};
